import styled, { injectGlobal, keyframes } from 'react-emotion'

export const colors = {
  tui_white: '#fff',
  tui_red: '#d40e14',
  tui_blue_100: '#70cbf4',
  tui_blue_50: '#c2e6fa',
  tui_blue_25: '#e2f3fe',
  tui_dark_blue: '#092a5e',
  tui_link_blue: '#219ed9',
  tui_light_red: '#ffeee8',
  tui_yellow: '#ffe100',
  tui_beige_25: '#f3f0ec',
  tui_beige_50: '#e7e3db',
  tui_beige: '#d7d2c3',
  tui_grey: '#737373',
  tui_grey_50: '#b9b9b9',
  tui_grey_25: '#dcdcdc',
  tui_border: '#dfdfdf',
  tui_warning: '#faebcc',
  tui_green: '#aad700',
  error_bg: '#ffe3e3',
  error_border: '#ce7373',
}

export const buttons = {
  function: 'btn-function',
  sales: 'btn-sales',
  ghost_blue: 'ghost-blue',
  ghost_white: 'ghost-white',
  ghost_link: 'ghost-link',
}

export const Container = styled('div')`
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 768px) {
    width: 744px;
  }
  @media (min-width: 992px) {
    width: 964px;
  }
  @media (min-width: 1200px) {
    width: 1164px;
  }
  ${(props) => props.fluid && `width: auto !important;`};
`

export const Shadow = styled('div')`
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
`

export const ShadowBox = styled(Shadow)`
  background-color: ${(props) => props.bgColor || colors.tui_white};
  margin: 10px 0;
  padding: 15px;
`

export const Divider = styled('div')`
  height: 2px;
  margin: 15px -15px;
  border-top: 1px solid ${colors.tui_border};
`

export const TableResponsive = styled('div')`
  overflow-x: auto;
  min-height: 0.01%;
  @media (max-width: 992px) {
    margin-bottom: 0;
    width: 100%;
    overflow-y: hidden;
  }
`

export const Table = styled('table')`
  width: 100%;
  max-width: 100%;
  td,
  thead > tr > th {
    padding: 8px;
    vertical-align: top;
  }
  tbody > tr > td,
  tfoot > tr > td {
    border-top: 1px solid ${colors.tui_blue_50};
  }
  thead > tr > th {
    border-bottom: 2px solid ${colors.tui_blue_50};
  }
  tfoot > tr > td {
    font-weight: bold;
  }
`

const bounce = keyframes`
 0% {
    transform: scale3d(0.8,0.8,.1);
  }
  100% {
    transform: scale3d(1,1,1);
  }
`

export const ModalOverlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 30001;
  background-color: rgba(0, 0, 0, 0.8);
  overflow-y: scroll;
`

export const ModalDialog = styled('div')`
  background-color: #fff;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  top: 5%;
  left: ${(props) =>
    props.width ? `calc(50% - ${props.width / 2}px)` : 'calc(50% - 400px)'};
  max-width: ${(props) => (props.width ? `${props.width}px` : `800px`)};
  width: 100%;
  padding: ${(props) => (props.padding ? `${props.padding}px` : `20px`)};
  margin-bottom: 80px;
  animation: ${bounce} 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  h2 {
    margin-top: 0 !important;
  }
  @media (max-width: 767px) {
    top: 40px;
    left: 2%;
    right: 2%;
    max-width: 96%;
    padding: 10px;
  }
`

export const Message = styled('div')`
  border: 1px solid;
  padding: 15px;
  border-radius: 4px;
  background-color: ${(props) =>
    props.error ? colors.error_bg : colors.tui_blue_25};
  border-color: ${(props) =>
    props.error ? colors.error_border : colors.tui_dark_blue};
`

injectGlobal`
  path {
    fill: currentColor;
  }
  body#mytui {
    background-color: ${colors.tui_beige_25};
  }
  body#mytui #customer-mytui-web-root {
    min-height: 600px;
  }
  body.x-tui-modal {
    overflow: hidden;
  }
  .cux-footer-main {
    margin-top: 50px !important;
  }
  input[type=checkbox] {
    margin-right: 5px;
  }
  input.input-validation-error,
  textarea.input-validation-error {
    border-radius: 4px 4px 0 0;
    border: 1px solid ${colors.error_border};
    border-bottom: 0;
  }

  .field-validation-error.validation-message {
    border: 1px solid ${colors.error_border};
    background: ${colors.error_bg};;
    display: block;
    padding: 8px;
  }

  .hotel-cards-list {
    margin: 0 -12px;
  }

  @media (max-width: 992px) {
    body#mytui #customer-mytui-web-root {
      min-height: 400px;
    }
    .cux-footer-main {
      margin-top: 15px !important;
    }
  }
  @media (max-width: 767px) {
    .hotel-cards-list {
      flex-flow: wrap;
    }
  }
`
